import { Button, CircularProgress } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import "../../assets/css/Button.css";

interface CustomButtonProps {
  handleButtonPress: () => void;
  isButtonDisabled: boolean;
  text: string ;
  isLoading?: boolean;
  isLoadingText?: string ;
  heightOverride?: string;
  widthOverride?: string;
  solid?: boolean;
  isDeleteButton?: boolean
  /** Extra or overriding MUI `Button` `sx` (merged on top of width/height defaults). */
  sx?: SxProps<Theme>;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  handleButtonPress,
  isButtonDisabled,
  text,
  isLoading = false,
  isLoadingText = 'Loading',
  heightOverride,
  widthOverride,
  solid = true,
  isDeleteButton = false,
  sx: sxOverride,
}) => {
  const appliedContent = isLoading ? (
    <>
      {isLoadingText} <CircularProgress size={12} color="inherit" />
    </>
  ) : (
    text
  );

  return (
    <Button
      disabled={isButtonDisabled}
      className={`${isDeleteButton ? 'error-button-solid' : solid ? 'primary-button-solid' : 'primary-button-clear'}`}
      onClick={isButtonDisabled ? undefined : handleButtonPress}
      disableRipple
      sx={[
        {
        height: heightOverride ?? '32px',
        width: widthOverride ?? 'max-content',
        minWidth: widthOverride ?? 'max-content',
        },
        ...(Array.isArray(sxOverride) ? sxOverride : [sxOverride ?? false]),
      ]}
    >
      {appliedContent}
    </Button>
  );
};

export { CustomButton };
